import { render, staticRenderFns } from "./PenalidadeAbaItens.vue?vue&type=template&id=3015e844&scoped=true"
import script from "./PenalidadeAbaItens.vue?vue&type=script&lang=js"
export * from "./PenalidadeAbaItens.vue?vue&type=script&lang=js"
import style0 from "./PenalidadeAbaItens.vue?vue&type=style&index=0&id=3015e844&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3015e844",
  null
  
)

export default component.exports